import { FilterNoneOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ComponentEmptyStatusView = function ComponentEmptyStatusView(props) {
  var className = props.className;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex w-full flex-col items-center space-y-1', className),
    children: [/*#__PURE__*/_jsx(FilterNoneOutlined, {
      className: "h-7 w-7"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle1",
      className: "font-bold",
      children: "No data"
    })]
  });
};

export default ComponentEmptyStatusView;